import PermintaanWorkOrderApi from "./PermintaanWorkOrderApi";

export default PermintaanWorkOrderApi;
